export const CV = {
  name: "Sude Dilara Akçagöz",
  nameUpper: "SUDE DILARA AKÇAGÖZ",
  role: "Marketing & Social Media",
  location: "Berlin, DE",
  email: "sude.dilara@outlook.de",
  phone: "+49 152 29229100",
  cvFile: "/lebenslauf-dilara-akcagoez-de.pdf",
  downloads: {
    cvDe: {
      href: "/lebenslauf-dilara-akcagoez-de.pdf",
      label: "Lebenslauf (DE)",
    },
    cvEn: {
      href: "/dilara-akcagoez-resume-en.pdf",
      label: "Resume (EN)",
    },
    portfolio: {
      href: "/arbeitsproben-dilara-akcagoez.pdf",
      label: "Arbeitsproben",
    },
  },
  portrait: "/sude-portrait.jpg",
  about:
    "Kreative Marketing- und Social-Media-Expertin mit einem scharfen Auge für digitale Trends. Von TikTok-Strategien über Influencer-Kollaborationen bis hin zu datengetriebenem SEA/SEO – ich verbinde kreatives Storytelling mit messbaren Ergebnissen und baue authentische Markenerlebnisse, die international funktionieren.",
  experience: [
    {
      period: "2025 — 2026",
      role: "Cultural Representative",
      company: "The Walt Disney Company",
      location: "Orlando, Florida, USA",
      bullets: [
        "Gästebetreuung auf höchstem Niveau in multikulturellem Umfeld",
        "Repräsentation deutscher Kultur und Merchandise gegenüber internationalen Gästen",
        "Zusammenarbeit in diversen, schnellen, internationalen Teams",
      ],
    },
    {
      period: "2024 — 2025",
      role: "Junior TikTok Creative",
      company: "DEPARTD",
      location: "Berlin",
      bullets: [
        "Entwicklung von TikTok-Konzepten und kreativen Kampagnenideen",
        "Trend-Research und Identifikation viraler Opportunities",
        "Verfassen von Copy und Skripten für TikTok-Content",
        "Performance-Analyse mit handlungsrelevanten Insights",
      ],
    },
    {
      period: "2023 — 2024",
      role: "Trainee Social Media & Influencer Marketing",
      company: "OUTFITTERY",
      location: "Berlin",
      bullets: [
        "Management von Influencer-Kollaborationen und Partnerschaften",
        "Begleitung plattformübergreifender Social-Media-Kampagnen",
        "Mitwirkung an Content-Strategie und Community-Management",
        "Kampagnen-Reports und Performance-Analysen",
      ],
    },
    {
      period: "2022 — 2023",
      role: "Marketing & Expansion",
      company: "Wonder Waffel",
      location: "Berlin",
      bullets: [
        "Unterstützung der Franchise-Expansion und lokaler Marketing-Initiativen",
        "Betreuung der Social-Media-Kanäle und Content-Erstellung",
        "Koordination von Werbematerialien und Promotion-Aktivitäten",
      ],
    },
    {
      period: "2021 — 2022",
      role: "Marketing",
      company: "PFOTENDOCTOR",
      location: "Berlin",
      bullets: [
        "Management von Social-Media-Kanälen und Community Engagement",
        "Digitale Content-Erstellung und E-Mail-Marketing",
        "Kundensupport und Anfragen-Management",
      ],
    },
    {
      period: "2018 — 2020",
      role: "Social Media Management",
      company: "Bontravo",
      bullets: [
        "Unterstützung im Social-Media-Management und in der Content-Planung",
        "Content-Erstellung und plattformübergreifendes Scheduling",
        "Community Engagement und Audience-Wachstum",
      ],
    },
  ],
  education: [
    {
      period: "2018 — 2023",
      title: "International Business Administration, B.Sc.",
      institution: "Europa-Universität Viadrina, Frankfurt (Oder)",
      note: "Note: 1,7",
    },
    {
      period: "2021",
      title: "Auslandssemester",
      institution: "Marmara University, Istanbul",
    },
    {
      period: "2010 — 2017",
      title: "Abitur",
      institution: "Luise-Henriette-Gymnasium, Berlin",
    },
  ],
  skills: ["TIKTOK", "SEA", "SEO", "MS OFFICE", "PROJEKTMANAGEMENT", "INFLUENCER MARKETING", "CONTENT CREATION", "CAMPAIGN ANALYTICS"],
  languages: [
    { name: "Deutsch", level: "Muttersprache" },
    { name: "Türkçe", level: "Muttersprache" },
    { name: "English", level: "Fließend" },
  ],
};
